import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-violet/15" data-id="element-397">
    <div className="flex items-center mb-4" data-id="element-398">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-violet font-serif font-bold text-sm md:text-xl border border-brand-violet/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-399">
        {initials}
      </div>
      <div data-id="element-400">
        <div className="flex text-brand-goldDark mb-1 text-[15px]" data-id="element-401">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-402" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-403">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-404">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-405">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MR',
    name: 'María R.',
    location: 'Rosario',
    text: 'El genograma sistémico cambió la manera en que leo el campo desde la primera sesión. Ahora llego al consultorio con una dirección clara y mis procesos tienen mucha más profundidad.'
  }, {
    initials: 'PG',
    name: 'Pablo G.',
    location: 'Buenos Aires',
    text: 'El Vademécum de Intervención me salvó en una sesión muy intensa. Tenía el campo detenido y en dos minutos encontré la lectura sistémica que necesitaba. Nunca más improviso.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Córdoba',
    text: 'La Bitácora Fenomenológica es lo que más valoran mis consultantes, aunque no lo sepan. El seguimiento mejoró tanto que ahora los procesos tienen una continuidad que antes no tenía.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-406">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-407">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-408" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MR',
    name: 'María R.',
    location: 'Rosario',
    product: 'Kit + Maestría',
    text: 'Los protocolos del Vademécum me dieron la seguridad que necesitaba. Ahora entro a cada sesión sabiendo exactamente hacia dónde ir cuando el campo se detiene.'
  }, {
    initials: 'PG',
    name: 'Pablo G.',
    location: 'Buenos Aires',
    product: 'Constelador',
    text: 'Con el Protocolo de Cierre de Sesión del Tomo 5, mis consultantes terminan cada proceso con una imagen clara. Eso no pasaba antes. Los procesos ahora tienen un hilo real.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Córdoba',
    product: 'Terapeuta Sistémica',
    text: 'La planilla de seguimiento del Tomo 3 es lo que más uso. En una sola hoja tengo todo lo que necesito para arrancar cada sesión con continuidad y claridad total.'
  }, {
    initials: 'RA',
    name: 'Ricardo A.',
    location: 'Mendoza',
    product: 'Constelador Familiar',
    text: 'El Kit Express de Frases Sanadoras es un recurso que no existía en ningún lado en español. Por primera vez tengo las palabras exactas para cada momento del campo.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-409">
      <div className="text-center mb-12" data-id="element-410">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-violetDark pt-[0px]" data-id="element-411">
          ❤️ MÁS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-412">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-413" />)}
      </div>
    </Section>;
};